"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lottieAnimation = _interopRequireDefault(require("../../../../lottie-animation"));

var _loaderLottie = _interopRequireDefault(require("./lottie/loader-lottie.json"));

const GridLoader = () => /*#__PURE__*/_react.default.createElement(_lottieAnimation.default, {
  data: _loaderLottie.default
});

var _default = GridLoader;
exports.default = _default;